(() => {
  const isHome = document.body.classList.contains('template-index');
  if (!isHome) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Scroll reveal
  const revealElements = [
    ...document.querySelectorAll('[data-lb-reveal]'),
    ...document.querySelectorAll('.template-index .collection__title, .template-index .card-wrapper .card')
  ];
  revealElements.forEach((el) => el.classList.add('lb-reveal'));
  document.documentElement.classList.add('lb-scroll-ready');

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('lb-inview');
          io.unobserve(entry.target);
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.22 }
    );
    revealElements.forEach((el) => io.observe(el));
  } else {
    revealElements.forEach((el) => el.classList.add('lb-inview'));
  }

  // Video scroll scrubbing
  const scene = document.querySelector('[data-lb-video-scene]');
  const video = document.querySelector('[data-lb-video]');
  if (!scene || !video || reduceMotion) return;

  let ticking = false;

  const updateScene = () => {
    const rect = scene.getBoundingClientRect();
    const maxScroll = Math.max(rect.height - window.innerHeight, 1);
    const progress = Math.min(Math.max(-rect.top / maxScroll, 0), 1);
    scene.style.setProperty('--lb-vid-progress', progress.toFixed(4));
    if (video.readyState >= 2 && video.duration) {
      video.currentTime = progress * video.duration;
      video.pause();
      scene.style.setProperty('--lb-vid-time', video.currentTime.toFixed(3));
    }
    ticking = false;
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateScene);
  };

  video.addEventListener('loadedmetadata', updateScene);
  video.addEventListener('canplay', () => {
    updateScene();
    video.style.opacity = '1';
  });
  video.addEventListener('play', () => video.pause(), { once: false });

  updateScene();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
})();
